/* eslint-disable react/prop-types */
import { useEffect, useState } from "react";

import Card from "@mui/material/Card";
import { formatDate, formatCurrency } from "utils";
import SoftBox from "components/SoftBox";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import DataTable from "./DataTable";
import ActionCell from "./components/ActionCell/index";
import { ProjectCostLedgerService } from "services/project-cost-ledger";

const renderData = (items, setDataTable) => {
  return items.map((item) => {
    const docDateObj =
      item.items && item.items[0] && item.items[0].documentDate
        ? new Date(item.items[0].documentDate)
        : null;
    const docDate = docDateObj ? docDateObj.toLocaleDateString("vi-VN") : "";

    const getTotal = (type) => {
      // Ưu tiên backend populated
      if (item.totalArising && item.totalArising[type]) {
        return parseFloat(item.totalArising[type]) || 0;
      }
      // Fallback local sum
      return item.items?.reduce((sum, it) => sum + (parseFloat(it.costs?.[type]) || 0), 0) || 0;
    };

    return {
      id: item._id,
      documentNumber: item.documentNumber || item.code || "",
      docDate,
      company: item.company?.name || "N/A",
      projectName: item.projectName || "N/A",
      totalArisingAmount: formatCurrency.format(getTotal("totalAmount")),
      totalConstruction: formatCurrency.format(getTotal("constructionAmount")),
      createdAt: formatDate(item.createdAt),
      action: <ActionCell item={item} setDataTable={setDataTable} />,
    };
  });
};

const tableData = {
  columns: [
    // {
    //   Header: "Số chứng từ",
    //   accessor: "documentNumber",
    // },
    // {
    //   Header: "Ngày chứng từ",
    //   accessor: "docDate",
    // },
    // {
    //   Header: "Đơn vị",
    //   accessor: "company",
    //   width: "20%",
    // },
    {
      Header: "Ngày tạo",
      accessor: "createdAt",
    },
    {
      Header: "Dự án",
      accessor: "projectName",
      width: "20%",
    },
    {
      Header: "Tổng phát sinh",
      accessor: "totalArisingAmount",
      width: "15%",
    },
    {
      Header: "Xây lắp",
      accessor: "totalConstruction",
      width: "15%",
    },
    { Header: "Thao tác", accessor: "action", sorted: false },
  ],
  rows: [],
};

function ProjectCostLedger() {
  const [loading, setLoading] = useState(false);
  const [dataTable, setDataTable] = useState(tableData);
  const [query, setQuery] = useState({ sortBy: "createdAt", sortType: "desc" });
  const [checkCreate, setCheckCreate] = useState(true);
  const [paginationData, setPaginationData] = useState({
    page: 1,
    count: 0,
    size: 10,
  });

  useEffect(() => {
    fetchData();
  }, [query, paginationData.page]);

  const fetchData = async () => {
    try {
      setLoading(true);

      const response = await ProjectCostLedgerService.getPaginate({
        ...query,
        page: paginationData.page,
        size: paginationData.size,
      });

      const { items, checkCreate: createPerm, paginate } = response.data || response;
      setCheckCreate(createPerm ? false : true);
      setPaginationData((prev) => ({
        ...prev,
        count: paginate?.count || 0,
        size: paginate?.size || 10,
      }));

      setDataTable((prev) => ({
        ...prev,
        rows: renderData(items || [], setDataTable),
      }));

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Lỗi lấy dữ liệu Sổ Chi Phí Đầu Tư Xây Dựng:", error);
      setDataTable((prev) => ({ ...prev, rows: [] }));
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox my={3}>
        <Card style={{ height: "100%" }}>
          <DataTable
            checkCreate={checkCreate}
            query={query}
            table={dataTable}
            loading={loading}
            setQuery={setQuery}
            paginationData={paginationData}
            setPaginationData={setPaginationData}
          />
        </Card>
      </SoftBox>
    </DashboardLayout>
  );
}

export default ProjectCostLedger;
